<template>
    <div class="HeaderBar">
        <nav class="navbar container" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
            <div class="company-name">
                <h1>Art Transplant</h1>
            </div>

            <a
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbarBasicExample"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
            </div>

            <div id="navbarBasicExample" class="navbar-menu">
            <div class="navbar-start">
                <NavLinks />
            </div>

            <div class="navbar-end">
                <div class="navbar-item">
                <Social />
                </div>
            </div>
            </div>
        </nav>
    </div>
</template>
<script>
import NavLinks from '../components/NavLinks.vue';
import Social from '../components/Social.vue';

export default {
    name: 'HeaderBar',
    components: {
        NavLinks,
        Social,
    },
    computed: {},
    mounted() {
        /* eslint-disable */
        // Check for click events on the navbar burger icon
        $('.navbar-burger').click(function() {
            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            $('.navbar-burger').toggleClass('is-active');
            $('.navbar-menu').toggleClass('is-active');
        });
    },
    data() {
        return {};
    },
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

.HeaderBar {
    background: $deepBlue;    
    position: fixed;
    width: 100%;
    z-index: 999;
}

.navbar {
    background : transparent;
    .company-name {
        color: $white;
        margin-top: 10px;
        margin-right: 30px;
        margin-left: 10px;
        text-transform: lowercase;
        white-space: nowrap;
        
        h1 { 
            font-weight: 300; 
        }

        &:after {
            display: block;
            content: '';
            height: 1px;
            padding-left: 80px;
            margin-left: -80px;
            margin-top: 5px;
            margin-bottom: 10px;
            background: -webkit-linear-gradient( to left, $secondaryColor, $darkGrey);
            background: -o-linear-gradient(to left, $secondaryColor, $darkGrey);
            background: -moz-linear-gradient( to left, $secondaryColor, $darkGrey);
            background: linear-gradient(to left, $secondaryColor, $darkGrey);
        }
    }

    .navbar-menu {
        background: $deepBlue;    
    }
}
</style>
